export default "__VITE_ASSET__C7Zip2n3__"